export default "__VITE_ASSET__CCMZjMH$__"